module.exports = __webpack_public_path__ + "static/img/bg2.8935a6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg2.jpg
// module id = /LkK
// module chunks = 11